<header class="header-mobile flex-between">
  <a class="header-mobile__logo"
     (click)="redirectToRoleRespectiveDashboard()"
     aria-label="Navigate to dashboard"
  >
    <img class="logo" src="assets/img/v2/general/logo-dark.svg" alt="Trinity medical solutions logo"/>
  </a>

  <button class="header-mobile__toggle flex-center" mat-icon-button (click)="toggleIsMenuOpen()">
    <mat-icon class="header-mobile__toggle-icon flex-center"
              [ngClass]="{ 'header-mobile__toggle-icon--animated': isMenuOpen }">
      {{ isMenuOpen ? 'close' : 'menu' }}
    </mat-icon>
  </button>
</header>
